import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { MerchantSnapshotDto } from 'src/generated-api-client';

type AgentLoanApplicationMerchantSnapshotGeneralInfoProps = {
    snapshot: MerchantSnapshotDto;
};

export const AgentLoanApplicationMerchantSnapshotGeneralInfo = observer(
    ({ snapshot }: AgentLoanApplicationMerchantSnapshotGeneralInfoProps) => {
        return (
            <Card
                title={t(
                    'Agent.LoanApplication.MerchantSnapshot.GeneralInfo.Title',
                )}
            >
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.MerchantSnapshot.GeneralInfo.MerchantName',
                            )}
                            value={snapshot.merchant?.name}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.MerchantSnapshot.GeneralInfo.SnapshotDate',
                            )}
                            value={snapshot.createdAt}
                            formatValue="date"
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
